import { connect } from 'react-redux';
import { fetchReservationUpcomingEvents } from '../../../redux/Reservation/sagas/routines';
import {
  getIsFetching,
  getOrder
} from '../../../redux/Reservation/selectors/upcoming-events';
import {
  clearReservationUpcomingEvents,
  reservationUpcomingEventsOnChangePage,
  reservationUpcomingEventsOnChangeOrder
} from '../../../redux/Reservation/actions/upcoming-events';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Reservation/selectors/upcoming-events/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import SEARCH_CONTEXT from '../../../constants/reservation/SearchContext';
import EventList from '../../../components/reservations/EventList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.UPCOMING_EVENTS
  );
  const order = getOrder(state);
  return {
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchReservationUpcomingEvents());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchReservationUpcomingEvents(query));
      else dispatch(reservationUpcomingEventsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearReservationUpcomingEvents());
      dispatch(fetchReservationUpcomingEvents(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearReservationUpcomingEvents());
      dispatch(fetchReservationUpcomingEvents({ ...query, order }));
      dispatch(reservationUpcomingEventsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventList);
